//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      },
      required: true
    },
    profiling: {
      type: Object,
      default: null
    },
    execution: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      pagination_details: {
        total: 0,
        limit: 10,
        current: 1
      },
      expanded: [],
      search: ''
    };
  },
  computed: {
    rowCount: function rowCount() {
      if (this.execution && this.execution.dataProfileResult && this.execution.dataProfileResult.rowCount != null) {
        return this.execution.dataProfileResult.rowCount;
      }
      return null;
    },
    columnCount: function columnCount() {
      return this.items ? this.items.length : 0;
    },
    scopeLabel: function scopeLabel() {
      if (!this.profiling || !this.profiling.scope) return '';
      if (this.profiling.scope === 'FULL') return 'Completo';
      if (this.profiling.scope === 'INCREMENTAL') return 'Incremental';
      return this.profiling.scope;
    },
    scheduleText: function scheduleText() {
      if (!this.profiling) return '';
      if (this.profiling.cron_type === 'UNIQUE') return 'Ejecución única';
      if (this.profiling.cron_type === 'CRON' && this.profiling.cron) return this.profiling.cron;
      return '';
    },
    hasFilters: function hasFilters() {
      if (!this.profiling) return false;
      return !!(this.profiling.row_filter || this.profiling.include_fields && this.profiling.include_fields.length || this.profiling.exclude_fields && this.profiling.exclude_fields.length);
    },
    showSummary: function showSummary() {
      return !!(this.profiling || this.execution && this.execution.dataProfileResult);
    },
    headers_details: function headers_details() {
      return [{
        value: 'data-table-expand',
        text: '',
        sortable: false,
        width: '48px'
      }, {
        value: 'column',
        text: this.traductor('data_quality.dataplex.profiling.execution_field.column')
      }, {
        value: 'type',
        text: this.traductor('data_quality.dataplex.profiling.execution_field.type'),
        width: '120px'
      }, {
        value: 'null_ratio',
        text: this.traductor('data_quality.dataplex.profiling.execution_field.null_ratio'),
        width: '170px'
      }, {
        value: 'distinct_ratio',
        text: this.traductor('data_quality.dataplex.profiling.execution_field.distinct_ratio'),
        width: '170px'
      }];
    }
  },
  methods: {
    nullPct: function nullPct(item) {
      if (!item.profile || item.profile.nullRatio == null) return 0;
      var v = item.profile.nullRatio * 100;
      return v > 100 ? 100 : v;
    },
    distinctPct: function distinctPct(item) {
      if (!item.profile || item.profile.distinctRatio == null) return 0;
      var v = item.profile.distinctRatio * 100;
      return v > 100 ? 100 : v;
    },
    formatPct: function formatPct(val) {
      return this.roundTwoDecimal(val) + '%';
    },
    nullColor: function nullColor(pct) {
      if (pct >= 50) return 'red darken-1';
      if (pct >= 20) return 'amber darken-2';
      return 'green darken-1';
    },
    hasExpandableData: function hasExpandableData(item) {
      return !!(item.profile && (item.profile.stringProfile || item.profile.integerProfile || item.profile.doubleProfile || item.profile.topNValues && item.profile.topNValues.length));
    },
    displayTopValue: function displayTopValue(item, val) {
      if (item.type === 'DATETIME' || item.type === 'TIMESTAMP') {
        return this.parseDate(val.value);
      }
      var s = '' + val.value;
      return s.length > 18 ? s.substring(0, 18) + '…' : s;
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    parseDate: function parseDate(timestamp) {
      var date = new Date(timestamp * 1000);
      var year = date.getFullYear();
      var month = ('0' + (date.getMonth() + 1)).slice(-2);
      var day = ('0' + date.getDate()).slice(-2);
      return year + '-' + month + '-' + day;
    },
    roundTwoDecimal: function roundTwoDecimal(val) {
      return Math.round(val * 100) / 100;
    }
  }
};